import { ChannelDoc } from '@gooduncles/gu-app-schema';
import { ICellRendererParams } from 'ag-grid-community';
import { useEffect } from 'react';

import useSWRChannel from 'src/hooks/swr/useSWRChannel';

interface AgCellChannelProps extends ICellRendererParams {
  channelId: string;
  field: keyof ChannelDoc;
}

/**
 * 채널 정보를 조회 및 표시하는 CellRenderer 컴포넌트
 */
const AgCellChannel = (params: AgCellChannelProps) => {
  const channelId = params.channelId;
  const { channel } = useSWRChannel(channelId);
  const value = (channel?.[params.field] ?? '') as string;

  useEffect(() => {
    if (params.setValue) {
      params.setValue(value);
    }
  }, [params, value]);

  return <span>{value}</span>;
};

export default AgCellChannel;
